import React, { useState, useEffect, useRef, useMemo } from "react";
import styles from "./timer.module.css";
import ProgressCircle from "./ProgressCircle/ProgressCircle";
import "bootstrap/dist/css/bootstrap.min.css";
import { Button } from "reactstrap";
import countDown from "../../../assets/files/countDown.m4a";
import audioUrl from "../../../assets/files/new_bell.mp3";

import { screenState } from "../../../store/screen/slice";
import { useAppSelector } from "../../../store/hooks";

const Index = (props: any) => {
  const { config, scale, onUpdate, actionEnd } = props;
  const { username } = useAppSelector(state => screenState(state));
  const units = [10 * 60, 1 * 60, 10, 1];

  const [initTime, setInitTime] = useState(600);
  const [nums, setNums] = useState([0, 0, 3, 0]);
  const [time, setTime] = useState(initTime);
  const [isRunning, setIsRunning] = useState(0); // odd: running; even: paused; 0: not start
  const [targetTime, setTargetTime] = useState(initTime);
  const [countdown, setCountdown] = useState(5);

  const audio = useMemo(() => new Audio(audioUrl), [audioUrl]);
  const countDownAudio = useMemo(() => new Audio(countDown), [countDown]);

  const parentRef = useRef(null);
  const [Ratio, setRatio] = useState(1);

  useEffect(() => {
    const width = config.data.width < config.data.data.minWidth? config.data.data.minWidth : config.data.width;
    const height = config.data.height < config.data.data.minHeight? config.data.data.minHeight : config.data.height;
    setRatio(width / height);
  }, [config.data.width, config.data.height]);
  
  useEffect(() => {
    if (Object.hasOwnProperty.call(config.data.data, "Countdown")) {
      setCountdown(config.data.data.Countdown);
    }
    if (Object.hasOwnProperty.call(config.data.data, "Time")) {
      setTime(config.data.data.Time);
    }
    if (Object.hasOwnProperty.call(config.data.data, "Target")) {
      setTargetTime(config.data.data.Target);
    }
    if (Object.hasOwnProperty.call(config.data.data, "Start")) {
      if (config.data.data.Start === 0) setInitTime(time);
      setIsRunning(config.data.data.Start);
    } else {
      // initialize after refreshing
      config.data.data.Time = 600;
      config.data.data.Start = 0;
      config.data.data.Target = 600;
      setInitTime(600);
      setTime(600);
      setIsRunning(0);
      setTargetTime(600);
    }
  }, [config.data.data]);

  useEffect(() => {
    
  }, [Ratio]);

  useEffect(function() {
    let t = time;
    const newNums = [0, 0 , 0, 0];
    for (let index = 0; index < units.length; index++) {
      const unit = units[index];
      newNums[index] = Math.floor(t / unit);
      t -= newNums[index] * unit;
      if (t === 0) break;
    }
    setNums(newNums);
  }, [time]);

  useEffect(() => {
    if (isRunning % 2) {
      let timeoutId: any;
      let timeoutId2: any;
      if (time === 0) {
        const data = config.data.data;
        data.Start = 0;
        data.Time = initTime;
        data.Target = initTime;
        if (!username) {
          onUpdate({ id: config.data.id, data: {...data} });
        }

        setIsRunning(0);
        setTime(initTime);
        setTargetTime(initTime);
        audio.volume = 1;
        audio.play();
        timeoutId = setTimeout(() => {
          audio.pause();
          audio.currentTime = 0;
          return () => clearTimeout(timeoutId);
        }, 3000);
      } else {
        if (time <= countdown) {
          countDownAudio.volume = 1;
          countDownAudio.play();
          timeoutId2 = setTimeout(() => {
            countDownAudio.pause();
            countDownAudio.currentTime = 0;
            return () => clearTimeout(timeoutId2);
          }, 1000);
        }
        timeoutId = setTimeout(() => {
          const data = config.data.data;
          data.Time = time - 1;
          if (!username) {
            onUpdate({ id: config.data.id, data: {...data} });
          }

          setTime(time - 1)
        }, 1000);
      }
      return () => {
        clearTimeout(timeoutId);
        clearTimeout(timeoutId2);
      };
    }
  }, [isRunning, time]);

  const startTimer = () => {
    audio.pause();
    audio.currentTime = 0;
    countDownAudio.pause();
    countDownAudio.currentTime = 0;
    const data = config.data.data;
    data.Start = isRunning + 1;
    onUpdate({ id: config.data.id, data: {...data} });

    if (isRunning === 0) setInitTime(time);
    setIsRunning(isRunning + 1);
  }

  const resetTimer = () => {
    audio.pause();
    audio.currentTime = 0;
    countDownAudio.pause();
    countDownAudio.currentTime = 0;
    const data = config.data.data;
    data.Start = 0;
    data.Time = initTime;
    data.Target = initTime;
    onUpdate({ id: config.data.id, data: {...data} });

    setIsRunning(0);
    setTime(initTime);
    setTargetTime(initTime);
  }

  const ChangeButton = (prop: any) => {
    const updateTimer = (change: any) => {
      let t = time, t1 = targetTime;
      t += change;
      if (t < 0) t = 0;
      setTime(t);

      t1 += change;
      if (t1 < 0) t1 = 0;
      setTargetTime(t1);

      const data = config.data.data;
      data.Time = t;
      data.Target = t1;
      onUpdate({ id: config.data.id, data: {...data} });
    };

    const icon = prop.plus ? (
        <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" className="bi bi-plus" viewBox="0 0 16 16">
          <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/>
        </svg>
      ) : (
        <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" className="bi bi-dash" viewBox="0 0 16 16">
          <path d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8z"/>
        </svg>
    );
    return (
      <Button
        color="dark"
        className={`timerCount btn btn-ghost-dark absolute rounded-circle d-flex justify-content-center align-items-center p-0 boxShadow-none ${prop.type === "large"? "large-change" : "small-change"} ${ prop.type === "large"? (prop.plus? "top-12" : "bottom-12") : (prop.plus? "top-12" : "bottom-12")}`}
        outline
        onPointerDown={() => {updateTimer(prop.change)}}
        data-double-click="false"
      >
        {icon}
      </Button>
    )
  }

  const SmallTimer = (prop: any) => (
    <div className="core-color d-flex flex-column align-items-center">
      <div className="d-flex flex-row justify-content-around align-items-stretch h-100 w-100">
        <ProgressCircle progress={time / targetTime * 100} size={170} trackWidth={5} indicatorWidth={16} scale={scale} content={(
          <div className={`flex h-full flex-col items-center justify-center h-100 ${styles.content}`}>
            <ChangeButton change={10} plus={true} type={"small"} />
              <div className="d-flex h-100 w-100 flex-row align-items-center" style={{ gap: "4px" }}>
                {
                  nums.map((num, index) => {
                    const colon = (index === 1) ? (
                      <span className="fw-medium d-flex justify-content-center align-items-center fs-4" style={{ width: "8px" }}>:</span>
                    ) : (null) 
                    return (
                      <React.Fragment key={index}>
                        <span className="fw-medium d-flex justify-content-center align-items-center fs-3" style={{ width: "10px" }} key={index}>{num}</span>
                        {colon}
                      </React.Fragment>
                    );
                  })
                }
              </div>
            <ChangeButton change={10 * -1} plus={false} type={"small"} />
          </div>
        )} />
      </div>

      <div className="d-flex flex-row justify-content-between align-items-stretch h-100 w-100" style={{ marginTop: "-1rem" }}>
        <Button
          className="core-btn core-default-btn flex items-center justify-center rounded-circle events-none-inside cursor-pointer rounded-full timer-play-s"
          onPointerDown={startTimer}
          data-double-click="false"
        >
          {isRunning % 2 ? 
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60.47 60.47">
              <path d="M30.24,0A30.24,30.24,0,1,0,60.47,30.24,30.27,30.27,0,0,0,30.24,0Zm0,58.47A28.24,28.24,0,1,1,58.47,30.24,28.27,28.27,0,0,1,30.24,58.47Z" fill="#91e2ca"/>
              <path d="M40.73,27.18,27.28,17.69a3.74,3.74,0,0,0-5.89,3v19a3.74,3.74,0,0,0,3.74,3.74,3.75,3.75,0,0,0,2.15-.68l13.45-9.5a3.74,3.74,0,0,0,0-6.11Zm-1.15,4.48L26.13,41.15a1.74,1.74,0,0,1-2.74-1.42v-19a1.71,1.71,0,0,1,.94-1.54,1.71,1.71,0,0,1,1.8.12l13.45,9.5a1.75,1.75,0,0,1,0,2.84Z" fill="#91e2ca"/>
            </svg> : 
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60.47 60.47">
              <path d="M30.24,0A30.24,30.24,0,1,0,60.47,30.24,30.27,30.27,0,0,0,30.24,0Zm9.34,31.66L26.13,41.15a1.74,1.74,0,0,1-2.74-1.42v-19a1.71,1.71,0,0,1,.94-1.54,1.71,1.71,0,0,1,1.8.12l13.45,9.5a1.75,1.75,0,0,1,0,2.84Z" fill="#91e2ca"/>
            </svg>
          }
        </Button>
        <Button
          color="danger"
          className="core-default-btn rounded-circle d-flex justify-content-center align-items-center p-0 timer-stop-s"
          onPointerDown={resetTimer}
          data-double-click="false"
        >
          {isRunning % 2 ? 
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60.47 60.47">
              <path d="M30.24,0A30.24,30.24,0,1,0,60.47,30.24,30.27,30.27,0,0,0,30.24,0ZM38.7,38.7H21.77V21.77H38.7Z" fill="#ffc780"/>
            </svg> : 
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60.47 60.47">
              <path d="M38.79,19.77H21.68a1.92,1.92,0,0,0-1.91,1.91V38.79a1.92,1.92,0,0,0,1.91,1.91H38.79a1.92,1.92,0,0,0,1.91-1.91V21.68A1.92,1.92,0,0,0,38.79,19.77ZM38.7,38.7H21.77V21.77H38.7Z" fill="#ffc780"/>
              <path d="M30.24,0A30.24,30.24,0,1,0,60.47,30.24,30.27,30.27,0,0,0,30.24,0Zm0,58.47A28.24,28.24,0,1,1,58.47,30.24,28.27,28.27,0,0,1,30.24,58.47Z" fill="#ffc780"/>
            </svg>
          }
        </Button>
      </div>
    </div>
  )
  
  const LargeTimer = (prop: any) => {
    const {medium = false} = prop;
    const progress = !medium ? (
      <div className="h-100 d-flex flex-row align-items-center" style={{ padding: "30px" }}>
        <ProgressCircle progress={time / targetTime * 100} trackWidth={5} indicatorWidth={16} scale={scale} />
      </div>
    ) : (null)
    
    return (
      <div className="core-color d-flex flex-row align-items-center h-100">
        {progress}

        <div className="d-flex flex-row align-items-center h-100" style={{ gap: "4px", marginLeft: "-16px" }}>
          {
            units.map((unit, index) => {
              const colon = (index === 1) ? (
                <div className="d-flex h-100 flex-column align-items-center justify-content-center mx-1"style={{ width: "30px" }}>
                  <span className="fw-medium lineHeight-0 fs-80">:</span>
                </div>
              ) : (null)
              return (
                <React.Fragment key={index}>
                  <div className="relative d-flex h-100 flex-column align-items-center justify-content-center timer-y">
                    <ChangeButton change={unit} plus={true} type={"large"} />
                    <span className="fw-medium lineHeight-0 fs-80">{nums[index]}</span>
                    <ChangeButton change={unit * -1} plus={false} type={"large"} />
                  </div>
                  {colon}
                </React.Fragment>
              )
            })
          }
        </div>

        <div className="absolute d-flex flex-column align-items-center timer-button">
          <Button
            className="core-btn core-default-btn flex items-center justify-center rounded-circle events-none-inside cursor-pointer rounded-full timer-play"           
            onPointerDown={startTimer}
            data-double-click="false"
          >
            {isRunning % 2 ? 
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60.47 60.47">
                <path d="M30.24,0A30.24,30.24,0,1,0,60.47,30.24,30.27,30.27,0,0,0,30.24,0Zm0,58.47A28.24,28.24,0,1,1,58.47,30.24,28.27,28.27,0,0,1,30.24,58.47Z" fill="#91e2ca"/>
                <path d="M40.73,27.18,27.28,17.69a3.74,3.74,0,0,0-5.89,3v19a3.74,3.74,0,0,0,3.74,3.74,3.75,3.75,0,0,0,2.15-.68l13.45-9.5a3.74,3.74,0,0,0,0-6.11Zm-1.15,4.48L26.13,41.15a1.74,1.74,0,0,1-2.74-1.42v-19a1.71,1.71,0,0,1,.94-1.54,1.71,1.71,0,0,1,1.8.12l13.45,9.5a1.75,1.75,0,0,1,0,2.84Z" fill="#91e2ca"/>
              </svg> : 
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60.47 60.47">
                <path d="M30.24,0A30.24,30.24,0,1,0,60.47,30.24,30.27,30.27,0,0,0,30.24,0Zm9.34,31.66L26.13,41.15a1.74,1.74,0,0,1-2.74-1.42v-19a1.71,1.71,0,0,1,.94-1.54,1.71,1.71,0,0,1,1.8.12l13.45,9.5a1.75,1.75,0,0,1,0,2.84Z" fill="#91e2ca"/>
              </svg>
            }
          </Button>
          <Button
            className="core-default-btn rounded-circle d-flex justify-content-center align-items-center p-0 boxShadow-none timer-stop"
            onPointerDown={resetTimer}
            data-double-click="false"
          >
            {isRunning % 2 ? 
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60.47 60.47">
                <path d="M30.24,0A30.24,30.24,0,1,0,60.47,30.24,30.27,30.27,0,0,0,30.24,0ZM38.7,38.7H21.77V21.77H38.7Z" fill="#ffc780"/>
              </svg> : 
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60.47 60.47">
                <path d="M38.79,19.77H21.68a1.92,1.92,0,0,0-1.91,1.91V38.79a1.92,1.92,0,0,0,1.91,1.91H38.79a1.92,1.92,0,0,0,1.91-1.91V21.68A1.92,1.92,0,0,0,38.79,19.77ZM38.7,38.7H21.77V21.77H38.7Z" fill="#ffc780"/>
                <path d="M30.24,0A30.24,30.24,0,1,0,60.47,30.24,30.27,30.27,0,0,0,30.24,0Zm0,58.47A28.24,28.24,0,1,1,58.47,30.24,28.27,28.27,0,0,1,30.24,58.47Z" fill="#ffc780"/>
              </svg>
            }
          </Button>
        </div>
      </div>
    );
  }

  return (
    <div className={`componentCore  timer-box parent d-flex ${ Ratio <= 2.57? `justify-content-center` : `justify-content-start` } align-items-center w-100`} style={{minWidth: "min-content", minHeight: "min-content", width: "inherit", height: "inherit", marginInline: "auto"}} ref={parentRef}>
      {Ratio < 1.84? (
        <SmallTimer />
      ) : (
        <LargeTimer medium={Ratio <= 2.57} />
      )}
      {username? (
        <div className="absolute h-100 w-100 top-0 start-0" style={{ zIndex: 2 }}></div>
      ) : null}
    </div>
  );
};

export default Index;